<template>
    <div class="container-fluid p-0 custom-carousel-section">
        <div class="row">
            <div class="col">
                <div class="custom-carousel">
                    <div class="custom-carousel-slides" :style="`transform: translateX(-${currentSlide * 100}%)`">
                        <div class="custom-carousel-slide" v-for="slide in slides" :key="slide.id" :style="{
                            backgroundImage: 'url(' + slide.image + ')',
                        }">
                            <div
                                style="position: absolute; inset: 0px; z-index: 1;">
                            </div>
                            <div class="caption">
                                <h1 class="display-4 fw-bold text-white">{{ slide.title }}</h1>
                            </div>
                        </div>
                    </div>

                    <div class="controls">
                        <button @click="prevSlide" class="prev-btn">‹</button>
                        <button @click="nextSlide" class="next-btn">›</button>
                    </div>

                    <div class="indicators">
                        <span v-for="(slide, index) in slides" :key="'indicator-' + index"
                            :class="['indicator', { active: currentSlide === index }]" @click="goToSlide(index)"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import hero1 from "@/assets/hero1.png";
import hero2 from "@/assets/hero2.png";
import hero3 from "@/assets/hero3.png";
import hero4 from "@/assets/hero4.png";
import hero5 from "@/assets/hero5.png";

export default {
    name: "CustomCarousel",
    data() {
        return {
            currentSlide: 0,
            slides: [
                {
                    id: 1,
                    title: "How’s Your Sleep?",
                    subtitle: "Your health is our priority.",
                    image: hero1,
                },
                {
                    id: 2,
                    title: "How’s Your Sleep?",
                    subtitle: "Discover how we can help you.",
                    image: hero2,
                },
                {
                    id: 3,
                    title: "How’s Your Sleep?",
                    subtitle: "Discover how we can help you.",
                    image: hero3,
                },
                {
                    id: 4,
                    title: "How’s Your Sleep?",
                    subtitle: "Discover how we can help you.",
                    image: hero4,
                },
                {
                    id: 5,
                    title: "How’s Your Sleep?",
                    subtitle: "Discover how we can help you.",
                    image: hero5,
                },
            ],
        };
    },
    methods: {
        prevSlide() {
            this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
        },
        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
        autoScroll() {
            this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        },
        goToSlide(index) {
            this.currentSlide = index;
        },
    },
    mounted() {
        this.autoScrollInterval = setInterval(this.autoScroll, 3000);
    },
    beforeUnmount() {
        clearInterval(this.autoScrollInterval);
    },
};
</script>

<style scoped>
.custom-carousel-section {
    overflow: hidden;
}

.custom-carousel {
    position: relative;
    overflow: hidden;
    width: 100%;
}

.custom-carousel-slides {
    display: flex;
    transition: transform 0.5s ease;
}

.custom-carousel-slide {
    flex: 0 0 100%;
    background-size: cover;
    background-position: center;
    height: 450px;
    position: relative;
}

.caption {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.5);
    padding: 15px;
    border-radius: 5px;
    z-index: 1;
    text-align: center;
}

.controls {
    position: absolute;
    top: 50%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    transform: translateY(-50%);
    display: none;
}

.prev-btn,
.next-btn {
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 10px;
    cursor: pointer;
    font-size: 24px;
}

.prev-btn:hover,
.next-btn:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

.indicators {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
}

.indicator {
    width: 10px;
    height: 10px;
    background-color: rgba(255, 255, 255, 0.5);
    margin: 0 5px;
    border-radius: 50%;
    cursor: pointer;
    display: none;
}

.indicator.active {
    background-color: white;
}

@media screen and (max-width: 767px) {

    .custom-carousel-slide {
        height: 300px;
    }

    .caption {
        left: 0%;
        top: 50%;
        transform: translate(-0%, -50%);
        background-color: rgba(0, 0, 0, 0.5);
        padding: 15px;
        width: 100%;
        text-align: center;
    }
}
</style>